
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sectors/industry/[industry]",
      function () {
        return require("private-next-pages/sectors/industry/[industry].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sectors/industry/[industry]"])
      });
    }
  